export const company = {
  name: '3R Construction LLC',
  shortName: '3R Construction',
  phoneDisplay: '(206) 335-5488',
  phoneHref: 'tel:+1-206-335-5488',
  area: 'Seattle & surrounding areas',
};

export const services = [
  { name: 'Framing', description: 'Structural framing for additions, new walls and layout changes.' },
  { name: 'Painting', description: 'Interior and exterior painting with careful prep and clean lines.' },
  { name: 'Flooring', description: 'Hardwood, laminate, vinyl and tile, installed level and lasting.' },
  { name: 'Cabinet/Countertop', description: 'Cabinet and countertop installs that update a kitchen or bath.' },
  { name: 'Deck', description: 'New decks and deck repairs built for the Pacific Northwest weather.' },
  { name: 'Roof', description: 'Roof repair and replacement to keep your home dry and protected.' },
  { name: 'Fence', description: 'Fences for privacy, security and curb appeal.' },
  { name: 'Windows', description: 'Window replacement for better light, comfort and efficiency.' },
  { name: 'Bathroom', description: 'Bathroom remodels, from small refreshes to full renovations.' },
];

export const serviceNames = services.map((service) => service.name);

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Approach', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Contact', href: '#quote' },
];
